<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.QuerySendingLog')"
    width="600px"
    :close-on-click-modal="false"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
    />
    <span slot="footer">
      <el-button no="close" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { querySendLog } from '@/api/seaExport/edi'

export default {
  name: 'GoFreightLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.operator'),
          field: 'userName',
          width: 60
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperateTime'),
          field: 'status',
          width: 110
        }, {
          headerName: this.$t('SeaExport.sendStatus'),
          field: 'state',
          width: 70
        }, {
          headerName: this.$t('SeaExport.SendDataInformation'),
          field: 'logMessage',
          width: 200
        }, {
          headerName: this.$t('SeaExport.ReturnInformation'),
          field: 'returnMessage',
          width: 200
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        const loading = getLoading4Cxt(this)
        querySendLog({ key: this.jobUuid }).then(res => {
          this.rowData = res.data
        }).finally(() => {
          loading.close()
        })
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
      }
    }
  }
}
</script>
